const Backbone = window.Backbone;
export default new Backbone.Wreqr.EventAggregator();
